import React from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { Link } from "react-router-dom";

export default function PremiumSubscription() {
  return (
    <>
      <ClientNavbar />
      <div
        className="page-content"
        style={{
          background:
            "linear-gradient(135deg, rgb(240, 253, 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3, 186, 187) 100%)",
          minHeight: "100vh",
        }}
      >
          <div className="card shadow-sm p-4" style={{ borderRadius: "16px" }}>
            {/* Header */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
              <h4 className="fw-bold mb-2 mb-md-0">Premium Subscription</h4>
            </div>

            {/* Subscription Plans */}
            <div className="row g-4">
              {/* Basic Plan */}
              <div className="col-md-4">
                <div className="card text-center p-4 shadow-sm h-100">
                  <h5 className="fw-bold">Basic</h5>
                  <p className="text-muted">For Starters</p>
                  <h3 className="text-primary">₹499/mo</h3>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>✔ Access to Reports</li>
                    <li>✔ Email Support</li>
                    <li>❌ Priority Assistance</li>
                  </ul>
                  <button className="btn btn-primary">Choose Plan</button>
                </div>
              </div>

              {/* Standard Plan */}
              <div className="col-md-4">
                <div className="card text-center p-4 shadow-sm h-100 border border-primary">
                  <h5 className="fw-bold">Standard</h5>
                  <p className="text-muted">Most Popular</p>
                  <h3 className="text-primary">₹999/mo</h3>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>✔ All Basic Features</li>
                    <li>✔ Priority Support</li>
                    <li>✔ Monthly Insights</li>
                  </ul>
                  <button className="btn btn-primary">Choose Plan</button>
                </div>
              </div>

              {/* Premium Plan */}
              <div className="col-md-4">
                <div className="card text-center p-4 shadow-sm h-100">
                  <h5 className="fw-bold">Premium</h5>
                  <p className="text-muted">For Professionals</p>
                  <h3 className="text-primary">₹1499/mo</h3>
                  <ul className="list-unstyled mt-3 mb-4">
                    <li>✔ All Standard Features</li>
                    <li>✔ Dedicated Manager</li>
                    <li>✔ Advanced Analytics</li>
                  </ul>
                  <button className="btn btn-primary">Choose Plan</button>
                </div>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-4">
              {/* <Link to="/" className="text-decoration-none text-dark"> */}
                <button className="btn btn-primary px-4">Back</button>
              {/* </Link> */}
            </div>
          </div>
        </div>
    </>
  );
}
